export default function formatFileSize(byte: number): string {
  let num = byte;

  if (num < 1024) {
    return `${Math.round(num).toLocaleString()}B`;
  }

  num /= 1024;
  if (num < 1024) {
    return `${Math.round(num).toLocaleString()}KB`;
  }

  num /= 1024;
  if (num < 1024) {
    return `${Math.round(num).toLocaleString()}MB`;
  }

  num /= 1024;
  return `${Math.round(num).toLocaleString()}GB`;
}
